<template>
  <div style="height: 100%;" class="logoin">
    <div id="login-box" style="width: 39%;height: 52%;position: absolute;top:25%;left:30%;background-color: transparent;text-align: center">
      <p style="color: white;font-size: 1.92vw;font-family: 微软雅黑;">"河南省交通运输科学技术进步奖"申报系统</p>
      <div style="margin-top: 4%;">
        <el-input placeholder="请输入登录账号" size="large" v-model="username" style="border: 1px solid #2a71d8;border-radius: 5px;max-width: 50%;">
          <template slot="prepend"><img src="../assets/login_name.png" width="20vw" height="24vh"></template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input type="password" placeholder="请输入您的密码" v-model="password" style="border: 1px solid #2a71d8;border-radius: 5px;max-width: 50%;">
          <template slot="prepend"><img src="../assets/login_password.png" width="20vw" height="24vh"></template>
        </el-input>
      </div>
      <div style="width: 100%;max-width: 225px;margin-left:16%">
        <el-checkbox style="color: #ffffff;margin-top: 10px;margin-bottom: 10px;" v-model="isRemember">记住密码</el-checkbox>
      </div>
      <div style="width: 100%;">
        <el-button type="primary" @click="submitForm" class="btn_login" :disabled="isFunctionDisabled">{{ loginstatus }}</el-button>
      </div>
      <router-link to="/register">没有账号？点击注册</router-link>
    </div>
  </div>
</template>

<script>
import utils from './js/utils.js';

export default {
  name: "login",
  data() {
    return {
      username: '',
      password: '',
      isRemember: false,
      isFunctionDisabled: false,
      loginstatus: '立即登录',
    }
  },
  methods: {
    submitForm() {
      if (this.username == null || this.username == '' || this.password == null || this.password == '') {
        this.$message.error('用户名和密码不能为空！');
      } else {
        /*登录账号发送请求*/
        this.loginstatus = '登录中';
        this.isFunctionDisabled = true;
        this.$axios({
          method: 'post',
          url: this.GLOBAL.URL + 'user/passwordLogin',
          data: {
            username: utils.encrypt(this.username, 'sheyanyuan888@ab'),
            password: utils.encrypt(this.password, 'sheyanyuan888@ab')
          }
        }).then((res) => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 403) {
            this.isFunctionDisabled = false
            this.$message.error('服务器拒绝请求！');
          } else if (resp.code == 408) {
            this.isFunctionDisabled = false
            this.$message.error('服务器等候请求时发生超时！');
          } else if (resp.code == 500) {
            this.isFunctionDisabled = false
            this.$message.error('服务器内部错误！');
          } else if (resp.code == 1000) {
            this.isFunctionDisabled = false
            this.loginstatus = '立即登录';
            sessionStorage.setItem("username", resp.data.username);
            sessionStorage.setItem("token", resp.data.token);
            sessionStorage.setItem("createuserid", resp.data.createuserid);
            sessionStorage.setItem("userid", resp.data.userid);
            localStorage.setItem("token", resp.data.token);
            //设置cookie 7天过期
            if(this.isRemember){
              this.docCookies.setItem("real_loginname",this.username,new Date().getTime() + 24 * 60 * 60 * 1000 * 7)
              this.docCookies.setItem("real_password",this.password,new Date().getTime() + 24 * 60 * 60 * 1000 * 7)
            }
            this.docCookies.setItem("isRemember",this.isRemember,new Date().getTime() + 24 * 60 * 60 * 1000 * 7)
            //判断是管理员账户还是普通用户
            if (resp.data.createuserid==0) {
              this.$router.push({path: '/HomePage/PJGLhomepage/AduitAward_Manager'})
            } else if (resp.data.createuserid==1){
              this.$router.push({path: '/HomePage/PJGLhomepage/AduitAward_Company'})
            }
          } else {
            this.showFailMsg(resp.message)
            this.isFunctionDisabled = false
          }
        }, function (rs) {
        });
        /*定时10秒*/
        setTimeout(() => {
          if (this.isFunctionDisabled) {
            this.$message.error('登录失败，请检查网络是否正常！');
            this.isFunctionDisabled = false;
          }
          this.loginstatus = '立即登录';
        }, 10000);
      }
    },
    //设置cookie
    getCookie() {
      let isRemember = this.docCookies.getItem("isRemember")
      this.isRemember =eval(isRemember)
      if((this.isRemember==true)&&this.docCookies.hasItem("real_loginname")&&this.docCookies.hasItem("real_password")){
        this.username = this.docCookies.getItem("real_loginname")
        this.password = this.docCookies.getItem("real_password")
      }
    },

  },
  created() {
    this.getCookie()
  }
}
</script>

<style scoped>
.logoin {
  background: url("../assets/login_background.jpg");
}

.btn_login {
  width: 50%;
  background-color: #1a89ff;
  height: 5.8vh;
  border-radius: 1vw;
  font-size: 1.2vw;
  font-family: 微软雅黑;
  max-width: 450px;
}

.btn_login:hover {
  background-color: #2a71d8;
}

/deep/ .el-input__inner {
  height: 5vh;
  line-height: 6vh;
  font-size: 1.5vh;
}

a {
  color: white;
  text-decoration: none;
}

a:hover {
  color: #1a89ff;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue